import { validateFields } from "./fields-validator";
import { showLoader, hideLoader } from "../loader";
import { pushFormEvent } from "../../../../frontend/www-static/javascript/es6/form-analytics";

const phoneOptions = {
  mask: "+9{5,15}",
  placeholder: "",
  showMaskOnHover: false,
};

let activeForm = null;

function getFormMarker(formData) {
  return formData.get("typeform") || formData.get("action");
}

export function initFormValidator() {
  const forms = document.querySelectorAll("form:not(.js-no_validate)"); // Get all forms which should validated

  if (!forms.length) return;

  forms.forEach((form) => {
    const dismissButton = form.querySelector(".js-error-dismiss");
    if (dismissButton) {
      dismissButton.addEventListener("click", () =>
        form.classList.remove("m-error"),
      );
    }

    const isStepForm = form.dataset.stepForm;

    const inputFields = Array.from(form.elements).filter(
      (el) => ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName) && el.name,
    );

    if (!isStepForm) {
      initFieldsValidation(inputFields);
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isStepForm) {
        const hasInvalidFields = validateFields(inputFields);

        if (hasInvalidFields) {
          const firstInvalid = form.querySelector(".js-form_field.m-invalid");
          firstInvalid?.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
      }

      activeForm = form;

      grecaptcha.ready(() => {
        grecaptcha.execute(window.jxRecaptchaSiteKey, { action: "submit" }).then(onSubmitReCaptcha);
      });
    });
  });

  async function onSubmitReCaptcha(token) {
    if (!activeForm) return;

    const formData = new FormData(activeForm);
    const url = activeForm.getAttribute("action") || "/";
    const method = activeForm.method || "POST";

    formData.append("token", token);

    activeForm.classList.remove("m-success", "m-error");

    const defaultErrorText = "Something went wrong. Please try again later.";
    const errorMessageElem = activeForm.querySelector(".js-error-message");

    showLoader(activeForm);
    activeForm.scrollIntoView({ behavior: "smooth", block: "start" });

    try {
      const response = await fetch(url, {
        method: method,
        body: formData,
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      // SUCCESS state
      activeForm.classList.add("m-success");

      // Commercial leads go to submit-form, everything else to content-form —
      // see form-analytics.js.
      pushFormEvent(getFormMarker(formData), activeForm);

      setTimeout(() => activeForm.classList.remove("m-success"), 8000);
      activeForm.reset();

      hideLoader(activeForm);
    } catch (error) {
      // ERROR state
      activeForm.classList.add("m-error");
      hideLoader(activeForm);
    }
  }

  async function initFieldsValidation(inputFields) {
    const telFields = inputFields.filter((field) => field.type === "tel");

    if (telFields.length) {
      const { default: Inputmask } = await import("inputmask");
      telFields.forEach((field) => Inputmask(phoneOptions).mask(field));
    }

    inputFields.forEach((field) => {
      if (field.type === "checkbox") {
        field.addEventListener("change", () => validateSingleField(field));
      } else {
        field.addEventListener("blur", () => validateSingleField(field));

        // Clear error immediately as user types, but only if the field already has one
        field.addEventListener("input", () => {
          const formField = field.closest(".js-form_field");
          if (formField && formField.classList.contains("m-invalid")) {
            validateSingleField(field);
          }
        });
      }
    });
  }

  function validateSingleField(field) {
    validateFields([field]);
  }
}
